module.exports = __webpack_public_path__ + "static/media/waterloo-image.e3618bb4.png";